import { connect } from 'react-redux';

import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectTotalProducts } from 'src/redux/products/selectors/selectors';
import { selectActiveFacets } from 'src/redux/productsQuery/selectors/selectors';
import { TaxonomyListing } from './TaxonomyListing';

const mapStateToProps = (state: ReduxApplicationState, ownProps: { stickyTopBanner?: boolean }) => {
  const showProductsList =
    !state.products.error &&
    (selectTotalProducts(state) > 0 || selectActiveFacets(state).length > 0);

  return {
    pageLiveRegionText: state.accessibility.statusMessage,
    products: state.products,
    showProductsList,
    stickyTopBanner: ownProps.stickyTopBanner ?? false,
  };
};

export const TaxonomyListingContainer = connect(mapStateToProps)(TaxonomyListing);
